<app-card-consulta titulo="CSV">
  <div class="card text-center">
    <div class="card-body">
      <!-- <h5 class="card-title">(2) Site Senatran</h5> -->
      <p class="card-text mt-2">
        O CSV (Certificado de Segurança Veicular) é um dos processos exigidos
        pelo Detran para protocolar mudanças que alteraram a configuração de
        fábrica do veículo incluso classificações ou reclassificação de monta
        por colisões anotadas por agentes de trânsito. Esses dados podem ser
        obtidos acessando o portal do Senatran, clicando no botão abaixo.
      </p>
      <a
        href="https://portalservicos.senatran.serpro.gov.br/#/veiculos/consultar"
        target="_blank"
        class="btn"
        >Acessar Senatran</a
      >
    </div>
  </div>
</app-card-consulta>
